import { useEffect, useCallback } from 'react';
import { unstable_useBlocker as useBlocker } from 'react-router-dom';

import { useConfirmDialog } from '@bo-hooks/common/useModal';

const usePrompt = (isBlocked, forceRoute = false) => {
  const blocker = useBlocker(isBlocked);
  const { showConfirmDialog } = useConfirmDialog();

  const handleConfirm = useCallback(() => {
    showConfirmDialog(
      '수정중인 항목이 있습니다.\n저장없이 페이지 이동하시겠습니까?',
      () => blocker?.proceed?.(),
      () => blocker?.reset?.(),
      '확인'
    );
  }, [blocker, showConfirmDialog]);

  useEffect(() => {
    if (forceRoute) {
      blocker?.proceed?.();
      return;
    }

    if (blocker?.state === 'blocked') {
      isBlocked ? handleConfirm() : blocker?.reset?.();
    }
  }, [blocker, handleConfirm, isBlocked, forceRoute]);

  return { blocker };
};

export default usePrompt;
